import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-recompute-issue-score',
  templateUrl: './recompute-issue-score.component.html',
  styleUrls: ['./recompute-issue-score.component.scss']
})
export class RecomputeIssueScoreComponent implements OnInit {

  constructor(private examSchService: ExamScheduleService, private examService: ExamService, private snackBar: SnackbarService,) { }

  ngOnInit(): void {
  }

  async onConfirmationResult(yes: boolean) {
    if (yes) {  
      let data = {
        Ids: this.examSchService.selectedIds.map(x => parseInt(x)),
        NotifyCandidate: false, // Assuming no notification is needed for recompute
        SelectAll: this.examSchService.selectAll,
        ExaminationID: this.examService.selectedExamIds[0],
      }
      const res = await this.examSchService.restartExaminationSchedules(data) as any[];
      if (res !== null && res.length > 0) {
        res.forEach(e => {
          this.snackBar.error(e);
        })
      }
      else {
        this.snackBar.success('Issue Score(s) Recomputed Successfully!');
      }
      this.examSchService.reloadGrid.next(true);
    }
  }
}
